import { render, staticRenderFns } from "./CardDetailDrawer.vue?vue&type=template&id=3b3138c9&scoped=true"
import script from "./CardDetailDrawer.vue?vue&type=script&lang=js"
export * from "./CardDetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./CardDetailDrawer.vue?vue&type=style&index=0&id=3b3138c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3138c9",
  null
  
)

export default component.exports